import { gql } from '@apollo/client';

const FIND_STUDENT_ASSESSMENTS_OUTCOMES = gql`
  query StudentAssessmentOutcomes($where: StudentAssessmentOutcomesWhereInput) {
    studentAssessmentOutcomes(where: $where) {
      id
      assessmentQuestionId
      answerTypeId
      answerTypeOptionId
    }
  }
`;

export default FIND_STUDENT_ASSESSMENTS_OUTCOMES;
